import React from 'react'

const CustomPopup = ({ children, className }) => {
    return (
        <>
            <div className="popup_wrap">
                <div className={`popup ${className}`}>
                    {children}
                </div>
            </div>
        </>
    )
}

export default CustomPopup